export const MMS_MESSAGE_COST = 5
export const SMS_MESSAGE_COST = 1
export const LOW_CREDITS = 100

export const MONTHS = [
    { value: "0", label: "January" },
    { value: "1", label: "February" },
    { value: "2", label: "March" },
    { value: "3", label: "April" },
    { value: "4", label: "May" },
    { value: "5", label: "June" },
    { value: "6", label: "July" },
    { value: "7", label: "August" },
    { value: "8", label: "September" },
    { value: "9", label: "October" },
    { value: "10", label: "November" },
    { value: "11", label: "December" },
]

export const daysOfMonth = [...Array(28).keys()].map((item) => ({
    value: (item + 1).toString(),
    label: (item + 1).toString(),
}))

export const PLIVO_ERROR_CODES = {
    10: "Invalid Message",
    20: "Network Error",
    30: "Spam Detected",
    40: "Invalid Source Number",
    50: "Invalid Destination Number",
    60: "Loop Detected",
    70: "Destination Permanently Unavailable",
    80: "Destination Temporarily Unavailable",
    90: "No Route Available",
    100: "Prohibited by Carrier",
    110: "Message Too Long",
    150: "Recipient Registered for India DND",
    160: "DLT Registration Issue",
    200: "Source Number Blocked by STOP from Destination Number",
    300: "Failed to Dispatch Message",
    310: "WhatsApp phone number registration error",
    320: "WhatsApp Phone Number Verification Error",
    330: "Unsupported WhatsApp message type",
    340: "Template status error",
    350: "Template parameter errors",
    360: "WhatsApp Business Account Disabled",
    370: "WhatsApp Throttling Errors",
    380: "Re-engagement message",
    420: "Message Expired",
    450: "Destination Country Disabled",
    451: "Unusual Activity",
    900: "Insufficient Credit",
    910: "Account Disabled",
    950: "Daily Messaging Limit Reached for Your 10DLC Brand",
    960: "Limit Reached or Messages Caught by Spam Filter on Unverified or Pending Verification Toll-Free Number",
    1000: "Unknown Error",
    "2xxx": "HTTP Error Received From Message URL For Incoming SMS",
    120: "MMS Message Payload Too Large",
    130: "Unsupported Message Media",
    140: "Message Media Processing Failed",
}
